<form [formGroup]="form" *ngIf="form" autocomplete="really-off">
    <div fxLayout="row wrap" class="form-row">
        <div fxFlex="50" fxFlex.lt-md="100" class="form-field-container">
            <div fxLayout="row" fxLayoutalign="space-between">
                <h2 class="mat-headline-4" style="margin-bottom: 10px;">Admin contact details</h2>
            </div>
            <div>
                <h3>Address</h3>
                <app-address-editor [addressForm]="formAdminAddress"
                                    [countries]="countries"
                                    (countryUpdated)="handleCountryBlur($event)"></app-address-editor>
            </div>
            <div>
                <h3>Contact</h3>
                <app-contact-editor [contactForm]="formAdminContact"></app-contact-editor>
            </div>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100" class="form-field-container">
            <div fxLayout="row" fxLayoutAlign="space-between">
                <h2 class="mat-headline-4" style="margin-bottom: 10px;">Billing contact details</h2>
                <div>
                    <mat-checkbox class="example-margin" formControlName="billingSameAsAdmin">use same as admin</mat-checkbox>
                </div>
            </div>
            <div>
                <h3>Address</h3>
                <app-address-editor [addressForm]="formBillingAddress"
                                [countries]="countries"
                                (countryUpdated)="handleCountryBlur($event)"></app-address-editor>
            </div>
            <div>
                <h3>Contact</h3>
                <app-contact-editor [contactForm]="formBillingContact"></app-contact-editor>
            </div>
        </div>
    </div>
</form>